import React from "react";
import { ArrowBackCircle, AddOutline, TrashOutline } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import constantURI from "../URI"
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter"
import stylesWMS from "./stylesWMS";
import stylesMed from "../MedRep/stylesMed";

export default class AddTransfer extends React.Component {

    constructor() {
        super();
        this.state = {
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

    }

    render() {
        return (
            <div className="container-fluid vh-100" style={stylesWMS.mainContainer}>
                <div className="row pt-3">
                    <div className="col">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./Transfer")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                </div>
                <div className="mt-4 p-3 mb-4" style={stylesMed.cardBackgroundColor}>
                    <div className="row">
                        <div className="col">
                            <label>Name*:</label>
                            <input className="col form-control" value={this.state.name} onChange={this.onChangeName}
                                style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group">
                            <label>Type*:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.type} onChange={this.onChangeType}
                                name="sellist1" style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput}>
                                <option value=""></option>
                                <option value={1}>Doctor</option>
                                <option value={2}>Pharmacy</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>Phone:</label>
                            <input className="col form-control" value={this.state.phone} onChange={this.onChangePhone} type="number"
                                onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                style={stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group">
                            <label>Mobile:</label>
                            <input className="col form-control" value={this.state.mobile} onChange={this.onChangeMobile} type="number"
                                onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col form-group">
                            <label>Area:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.area} onChange={this.onChangeArea}
                                name="sellist1" style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.areas.map((item) => {
                                    return (
                                        <option value={item.id}>{item.name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                        <div className="col">
                            <label>Subarea:</label>
                            <select className="col-sm-6 form-control" id="sel1" value={this.state.subarea} onChange={this.onChangeSubarea}
                                name="sellist1" style={stylesMed.reportClientInput}>
                                <option value=""></option>
                                {this.state.subareas.map((item) => {
                                    return (
                                        <option value={item.id}>{item.x_name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>Email:</label>
                            <input className="col form-control" value={this.state.email} onChange={this.onChangeEmail}
                                style={stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group">
                            <label>Birthday:</label>
                            <DatePicker style={stylesMed.reportClientInput} className="form-control" selected={this.state.birthday} onChange={(date) => this.onChangeBirthday(date)} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col form-group">
                            <label>Address:</label>
                            <textarea className="col form-control" value={this.state.address} onChange={this.onChangeAddress}
                                style={stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group invisible">
                            <label>Birthday:</label>
                            <DatePicker className="form-control" selected={this.state.birthday} onChange={(date) => this.onChangeBirthday(date)} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
